export const transformCompensationDetails = (jsonData) => {
  const mappedData = {
    candidate: {
      compensationDetails: {
        total: jsonData.totalCompensation ? +jsonData.totalCompensation : null,
        fixed: jsonData.fixedCompensation ? +jsonData.fixedCompensation : null,
        variable: jsonData.variableCompensation ? +jsonData.variableCompensation : null,
        incentive: jsonData.incentive ? +jsonData.incentive : null,
        esop: jsonData.epos ? +jsonData.epos : null,
        otherBenefits: jsonData.otherBenefits ? +jsonData.otherBenefits : null,
        bonus: jsonData.bonus ? +jsonData.bonus : null,
        joiningBonus: jsonData.joiningBonus ? +jsonData.joiningBonus : null,
        currentYr1stIncrementPercentage: jsonData.firstYearIncrement ? +jsonData.firstYearIncrement : null,
        currentYr2ndIncrementPercentage: jsonData.secondYearIncrement ? +jsonData.secondYearIncrement : null,
        expectedCtc: jsonData.expectedCTC ? +jsonData.expectedCTC : null,
        fixedCtcExpectation: jsonData.fixedCtcExpectation ? +jsonData.fixedCtcExpectation : null,
        additionalNotes: jsonData.additionalNotes ? jsonData.additionalNotes : null,
      },
    },
  };

  return mappedData;
};

export const reverseTransformCompensationDetails = (mappedData) => {
  const jsonData = {};
  if (!mappedData) return jsonData;

  jsonData.totalCompensation = mappedData.total ?? null;
  jsonData.fixedCompensation = mappedData.fixed ?? null;
  jsonData.variableCompensation = mappedData.variable ?? null;
  jsonData.incentive = mappedData.incentive ?? null;
  jsonData.epos = mappedData.esop != null ? mappedData.esop.toString() : null;
  jsonData.otherBenefits = mappedData.otherBenefits != null ? mappedData.otherBenefits.toString() : null;
  jsonData.bonus = mappedData.bonus != null ? mappedData.bonus.toString() : null;
  jsonData.joiningBonus = mappedData.joiningBonus != null ? mappedData.joiningBonus.toString() : null;
  jsonData.firstYearIncrement = mappedData.currentYr1stIncrementPercentage != null
    ? mappedData.currentYr1stIncrementPercentage.toString()
    : null;
  jsonData.secondYearIncrement = mappedData.currentYr2ndIncrementPercentage != null
    ? mappedData.currentYr2ndIncrementPercentage.toString()
    : null;
  jsonData.expectedCTC = mappedData.expectedCtc != null ? mappedData.expectedCtc.toString() : null;
  jsonData.fixedCtcExpectation = mappedData.fixedCtcExpectation != null ? mappedData.fixedCtcExpectation.toString() : null;
  jsonData.additionalNotes = mappedData.additionalNotes ?? null;

  return jsonData;
};
